export const CURRENT_USER_FETCH      = 'CURRENT_USER_FETCH';
export const CURRENT_USER_FETCH_DONE = 'CURRENT_USER_FETCH_DONE';



// WEBPACK FOOTER //
// ./app/constants/currentUserTypes.js